// Status dot: green if pinged <5min ago, amber <30min, gray older/never
export const LiveStatusDot = ({ lastPingAt, testid = "live-dot" }) => {
  const now = Date.now();
  const t = lastPingAt ? new Date(lastPingAt).getTime() : 0;
  const diff = now - t;
  let color = "#9ca3af"; // gray
  let label = "offline";
  if (t && diff < 5 * 60 * 1000) {
    color = "#16a34a";
    label = "live";
  } else if (t && diff < 30 * 60 * 1000) {
    color = "#D4AF37";
    label = "recent";
  }
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest"
      style={{ color }}
      data-testid={testid}
    >
      <span
        className="w-2 h-2 rounded-full inline-block"
        style={{ background: color, boxShadow: color === "#16a34a" ? `0 0 0 3px ${color}33` : undefined }}
      />
      {label}
    </span>
  );
};
